import { generateTypes } from '../../utils/HttpReducerHelper';

const completeOnboarding = generateTypes('ONBOARDING', 'COMPLETE');

export { completeOnboarding };
